export default __webpack_public_path__ + "static/media/whatsapp-icon.f99de59b.png";